import { Component, computed, Input, input } from '@angular/core';
import {
  GcButtonComponent,
  GcIconColor,
  GcIconComponent,
  GcIconName,
  GcLinkComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { TraceIdContactInformationComponent } from '../trace-id-contact-information/trace-id-contact-information.component';

export interface ErrorTextIconData {
  iconName: GcIconName;
  iconColor: GcIconColor;
}

@Component({
  selector: 'app-error-information',
  templateUrl: './error-information.component.html',
  imports: [
    GcTextComponent,
    GcIconComponent,
    IpoTranslatePipe,
    GcButtonComponent,
    TraceIdContactInformationComponent,
    GcLinkComponent,
  ],
  styleUrl: './error-information.component.scss',
})
export class ErrorInformationComponent {
  iconName = input<GcIconName>();
  iconColor = input<GcIconColor>();
  errorTitle = input<string>();
  errorString = input<string>();
  refreshPageButton = input(false);
  navigateToUrl = input<string>('');
  traceId = input<string>();
  iconData = computed(() => {
    const iconName = this.iconName();
    const iconColor = this.iconColor();
    if (iconColor && iconName) {
      return { iconColor, iconName } as ErrorTextIconData;
    } else {
      return undefined;
    }
  });

  handleOnClickedRefreshPage(): void {
    this.reloadPage();
  }

  reloadPage(): void {
    return window.location.reload();
  }
}

@Component({
  selector: 'app-error-information',
  template: `MockedErrorInformationComponent`,
  standalone: true,
})
export class MockedErrorInformationComponent {
  @Input() iconName: GcIconName;
  @Input() iconColor: GcIconColor;
  @Input() errorTitle: string;
  @Input() errorString: string;
  @Input() refreshPageButton: boolean;
  @Input() navigateToUrl: string;
  @Input() traceId: string;
}
